"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncDictionaryProvider = exports.DictionaryProvider = exports.useDictionaryContext = void 0;
const react_1 = __importStar(require("react"));
const Context = (0, react_1.createContext)({});
const useDictionaryContext = () => (0, react_1.useContext)(Context);
exports.useDictionaryContext = useDictionaryContext;
const DictionaryProvider = ({ dictionary, children }) => (react_1.default.createElement(Context.Provider, { value: dictionary }, children));
exports.DictionaryProvider = DictionaryProvider;
const AsyncDictionaryProvider = ({ loader, request, children, }) => {
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [dictionary, setDictionary] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        setLoading(true);
        request().then((a) => {
            setDictionary(a);
            setLoading(false);
        });
    }, [request]);
    if (loading) {
        return react_1.default.createElement(react_1.default.Fragment, null, loader);
    }
    return react_1.default.createElement(exports.DictionaryProvider, { dictionary: dictionary }, children);
};
exports.AsyncDictionaryProvider = AsyncDictionaryProvider;
